import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID, DOCUMENT } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class WindowService {
    private document = inject(DOCUMENT);
    private platformId = inject(PLATFORM_ID);

    get scrollbarWidth() {
        return Math.abs(window.innerWidth - this.document.documentElement.clientWidth);
    }

    get isBrowser(): boolean {
        return isPlatformBrowser(this.platformId);
    }

    get isClient(): boolean {
        return isPlatformBrowser(this.platformId) === false;
    }

    checkWindowWidth(width: number): boolean {
        if (isPlatformBrowser(this.platformId)) {
            const windowWidth = this.document.body.offsetWidth;
            return windowWidth >= width ? true : false;
        }
        return true;
    }

    scrollTop(): void {
        if (this.isBrowser) {
            window.scrollTo(0, 0);
        }
    }

    scrollTo(top?: number): void {
        if (this.isBrowser) {
            window.scrollTo({
                top: top ? top : 0,
                behavior: 'smooth',
            });
        }
    }
}
